import { createAction } from '@reduxjs/toolkit';
import { responseFailed, bankDetailsFailed } from './error';
import { navigateToScreen } from './navigation';
import { showHideLoader } from './loader';
import {
  DIRECT_DEBIT_INSTRUCTIONS,
  CREDIT_CARD_DETAILS,
  GET_IN_TOUCH,
  DIP_DIRECT_DEBIT_INSTRUCTIONS
} from 'constants/paths';
import { getCaseList, updateCase } from './case';
import { getCustomers } from './customer';
import { NTB_JOURNEY, EXISTING_JOURNEY } from 'constants/general';

export const searchBankDetails = createAction(
  'case/searchBankDetails',
  function prepare({ accountNumber, sortCode }) {
    return {
      payload: {
        endPoint: 'ref/bank/search',
        method: 'post',
        body: searchCaseRequest(accountNumber, sortCode),
        isPaasApi: true,
        addHeader: true,
        success: bankDetailsSuccess,
        failure: bankDetailsFailed,
        version: '1.2.0'
      }
    };
  }
);

function searchCaseRequest(accountNumber, sortCode) {
  return {
    account_number: accountNumber,
    sort_code: sortCode
  };
}

export const bankDetailsSuccess = (response) => (dispatch, getState) => {
  dispatch(bankDetailsSuccessResponse(response));

  const { config, loanValues, form, caseDetails, customerInfo } = getState();
  //check secondary applicant and dispatch Update case for NTB & navigate to Credit Card for Existing journey
  if (config.isSecondaryApplicant) {
    if (config.journey === NTB_JOURNEY) {
      dispatch(
        updateCase(
          config,
          loanValues,
          form,
          caseDetails,
          customerInfo,
          caseDetails.caseId,
          'review'
        )
      );
    } else if (config.journey === EXISTING_JOURNEY) {
      dispatch(showHideLoader(false));
      dispatch(navigateToScreen(CREDIT_CARD_DETAILS));
    }
  } else {
    dispatch(showHideLoader(false));
    dispatch(
      navigateToScreen(
        config.skipDecisionInPrinciple ? DIRECT_DEBIT_INSTRUCTIONS : DIP_DIRECT_DEBIT_INSTRUCTIONS
      )
    );
  }
};

export const bankDetailsSuccessResponse = createAction(
  'case/bankDetailsSuccessResponse',
  function prepare(payload) {
    return {
      payload
    };
  }
);

export const getBankId = (isExisting, loanType) => (dispatch) => {
  dispatch(showHideLoader(true));
  dispatch(getBankIdFromToken(isExisting, loanType));
};

export const getBankIdFromToken = createAction(
  'search/getBankId',
  function prepare(isExisting, loanType) {
    return {
      payload: {
        endPoint: '/user/token',
        method: 'get',
        isPaasApi: true,
        addHeader: true,
        success: bankIdSuccess,
        successParam: {
          isExisting,
          loanType
        },
        failure: responseFailed,
        version: '1.2.0'
      }
    };
  }
);

export const bankIdSuccess = (response, param) => (dispatch, getState) => {
  if (!response || !response.bank_id) {
    dispatch(
      responseFailed({
        message: 'Bank ID: Empty response after service call'
      })
    );
  } else {
    const {
      config: { jointBankId }
    } = getState();

    if (jointBankId && jointBankId.toUpperCase() !== response.bank_id.toUpperCase()) {
      dispatch(
        navigateToScreen(GET_IN_TOUCH)
      ); /** @todo potentially rewrite the location instead of navigate */
      dispatch(showHideLoader(false));
    } else {
      dispatch(bankIdSuccessResponse(response));
      dispatch(getCustomers());
      dispatch(getCaseList(param.isExisting, param.loanType));
    }
  }
};

export const bankIdSuccessResponse = createAction(
  'search/bankIdSuccess',
  function prepare(response) {
    return {
      payload: response.bank_id
    };
  }
);

export const getBankIdFromSelector = createAction(
  'search/getBankIdFromSelector',
  function prepare() {
    return {
      payload: {
        endPoint: 'bank/selector/bankid/LSAP',
        method: 'get',
        isPaasApi: true,
        addHeader: true,
        useAuth: false,
        success: bankIdSelectorSuccess,
        failure: responseFailed,
        version: '1.2.0'
      }
    };
  }
);

export const bankIdSelectorSuccess = createAction(
  'search/bankIdSelectorSuccess',
  function prepare(response) {
    return {
      payload: response.data.bank_id
    };
  }
);
